import Swiper, { Navigation, Pagination } from 'swiper/core'
import { MOBILE_WIDTH } from 'www/library.blocks/common/b-popup-content/constants'
import 'swiper/swiper-bundle.css'

/**
 *@author @Bykov
 * @deprecated
 */

Swiper.use([Navigation, Pagination])

require('www/js/libs/magnific-popup/magnific-popup.css')
require('www/js/libs/magnific-popup/jquery.magnific-popup.min')

export default class {
  constructor(options) {
    this.init(options)
  }

  init(options) {
    if (!options) {
      throw new Error('Options is empty')
    }

    this.options = this._extendOptions(options)

    const merged = this.options

    if (!merged.beforeShow && !merged.selector && !merged.id && !merged.modifier) {
      return
    }

    this.renderCount = 0
    this.renderCountMax = 5
    this.slidesCurrent = merged.slideTo
    this.media = document.documentElement.clientWidth
    this.slidesTotal = 0
    this.modifier = 'b-popup-content'
    this.$magnific = $.magnificPopup
    this.sliderOptions = options.sliderOptions || {}

    this._createTemplates()
    this._createPopup()

    document.addEventListener('click', this._eventClick)
  }

  hide = () => {
    if (!this.options.id) {
      return
    }

    this.$magnific.close()
  }

  render = (data, slideTo) => {
    if (!this.options.id) {
      return
    }

    if (data) {
      this.slidesTotal = data.length
      this.response = data
      this._searchNodes()

      if (!this.nodes.cover) {
        if (this.renderCount < this.renderCountMax) {
          this.renderCount++

          setTimeout(() => {
            this.render(data, slideTo)
          }, 100)

          return
        }

        this.renderCount = 0

        return
      }

      this.renderCount = 0
    }

    let detail = ''
    let images = ''

    const { nodes, options, templates } = this
    const position = slideTo || this.slidesCurrent
    const currentObject = this.response[position]

    this.slidesCurrent = position

    if (!currentObject) {
      throw new Error('Object is empty')
    }

    if (nodes.title && options.createHead) {
      nodes.title.textContent = currentObject.name

      if (options.ellipsis) {
        nodes.title.classList.add(`${this.modifier}__title_ellipsis`)
      }

      if (data && options.createHideCross) {
        nodes.head.classList.add(`${this.modifier}__head_cross`)
        nodes.head.classList.add(`${options.modifier}__head_cross`)
        nodes.head.insertAdjacentHTML('afterbegin', templates.hideCross)
      }
    }

    if (options.createDescription && currentObject.attributes && currentObject.attributes.length !== 0) {
      if (data) {
        detail += `<div class="${this.modifier}__description ${options.modifier}__description">`
      }

      currentObject.attributes.forEach(({
        name = '',
        description = '',
      }) => {
        detail += `<div class="${this.modifier}__detail ${options.modifier}__detail">
                    <p class="${this.modifier}__detail-title ${options.modifier}__detail-title text-subtitle-1">${name}</p>
                    <p class="${this.modifier}__detail-text ${options.modifier}__detail-text text-body-1">${description}</p>
                </div>`
      })

      if (data) {
        detail += '</div>'
      }
    }

    if (options.createSlider && data) {
      data.forEach(({ image, name }) => {
        images += `<img src="${image}" alt="${name}" class="${this.modifier}__slide ${options.modifier}__slide">`
      })

      nodes.imageTrack.innerHTML = images
    }

    if (options.createDescription && currentObject.attributes && currentObject.attributes.length !== 0) {
      if (data) {
        nodes.body.insertAdjacentHTML('beforeend', detail)
      } else {
        const descriptionBox = nodes.body.getElementsByClassName(`${this.modifier}__description`)[0]

        descriptionBox.innerHTML = detail
      }
    }

    if (data) {
      this._appendPagination()
      this._appendNavigation()
      this._sliderInit()

      options.afterShow({
        nodes: this.nodes,
        slider: this.Slider,
        popup: this.$magnific,
        response: this.response,
      })
    }
  }

  initPopup = () => {
    $(this.options.selector).magnificPopup({
      fixedContentPos: true,
      removalDelay: 300,
      mainClass: this.classList,
      showCloseBtn: false,
      items: {
        src: this.popupBase,
        type: 'inline',
      },
      callbacks: {
        beforeOpen: () => {
          this._popupBeforeOpen(this.$magnific.instance.st.el[0])
        },
        afterClose: () => {
          this._popupAfterClose()
        },
      },
    })
  }

  _extendOptions(options = {}) {
    const optionsDefault = {
      id: null,
      slideTo: 0,
      selector: null,
      modifier: null,
      beforeShow: null,
      afterShow: () => {},
      afterClose: () => {},
      afterSlideChange: () => {},
      ellipsis: false,
      createHead: true,
      createSlider: true,
      createHideCross: false,
      createHideButton: true,
      createDescription: true,
      navigation: true,
      pagination: 'fraction',
      sliderOptions: null,
    }

    return { ...optionsDefault, ...options }
  }

  _createTemplates() {
    const { id } = this.options
    const { modifier } = this
    const customModifier = this.options.modifier

    this.templates = {
      head: `<div class="${modifier}__head ${customModifier}__head">
                        <p class="${modifier}__title ${customModifier}__title"></p>
                    </div>`,

      detail: `<div class="${modifier}__detail ${customModifier}__detail">
                            <p class="${modifier}_is-empty ${modifier}__detail-title ${customModifier}__detail-title text-subtitle-1"></p>
                            <p class="${modifier}_is-empty ${modifier}__detail-text ${customModifier}__detail-text text-body-1 text--text"></p>
                        </div>`,

      sliderBox: `<div class="${modifier}__image-box ${customModifier}__image-box">
                            <div class="${modifier}__image-container ${customModifier}__image-container" id="${id}__image-container">
                                <div class="${modifier}__image-track ${customModifier}__image-track"></div>
                            </div>
                        </div>`,

      hideBox: `<div class="${modifier}__hide-box ${customModifier}__hide-box">
                            <button class="${modifier}__hide-button ${customModifier}__hide-button b-button b-button_text b-button_blue"><span class="text-button">Закрыть</span></button>
                        </div>`,

      hideCross: `<button class="${modifier}__hide-cross ${customModifier}__hide-cross button-reset" type="button">
                            <span class="ui-icon-close-not-a-circle"></span>
                        </button>`,

      paginationBox: `<div class="${modifier}_is-empty ${modifier}__pagination ${customModifier}__pagination text-body-2 text-secondary--text"></div>`,

      navigationBox: `<div class="${modifier}__navigation ${customModifier}__navigation">
                                <button class="${modifier}__navigation-button_hidden ${modifier}__navigation-button ${modifier}__navigation-prev ${customModifier}__navigation-button ${customModifier}__navigation-prev"></button>
                                <button class="${modifier}__navigation-button_hidden ${modifier}__navigation-button ${modifier}__navigation-next ${customModifier}__navigation-button ${customModifier}__navigation-next"></button>
                            </div>`,

    }
  }

  _searchNodes() {
    this.nodes = {}

    const cover = document.getElementById(this.options.id)

    if (!cover) {
      return
    }

    this.nodes = {
      cover,
      head: cover.getElementsByClassName(`${this.modifier}__head`)[0],
      body: cover.getElementsByClassName(`${this.modifier}__body`)[0],
      container: cover.getElementsByClassName(`${this.modifier}__container`)[0],
      title: cover.getElementsByClassName(`${this.modifier}__title`)[0],
      imageBox: cover.getElementsByClassName(`${this.modifier}__image-box`)[0],
      imageTrack: cover.getElementsByClassName(`${this.modifier}__image-track`)[0],
    }
  }

  _eventClick = ({ target }) => {
    const hideCross = target.closest(`.${this.modifier}__hide-cross`)
    const hideButton = target.closest(`.${this.modifier}__hide-button`)

    if (hideCross || hideButton) {
      this.hide()
    }
  }

  _createPopupBase() {
    let markupBody = ''
    let markupContainer = ''

    const { options, templates } = this
    let bodyClassList = `${this.modifier}__body ${options.modifier}__body`

    if (options.createHead) {
      markupContainer += templates.head
    }

    if (options.createSlider) {
      markupBody += templates.sliderBox
    }

    if (options.createHideButton) {
      markupBody += templates.hideBox
    } else {
      bodyClassList += ` ${this.modifier}__body_round ${options.modifier}__body_round`
    }

    markupContainer += `<div class="${bodyClassList}">${markupBody}</div>`

    return `<div class="${this.modifier}__container ${options.modifier}__container mfp-with-anim" id="${options.id.replace(/#/g, '')}">${markupContainer}</div>`
  }

  _createPopup() {
    const { media } = this

    this.popupBase = this._createPopupBase()
    this.classList = `${this.modifier} mag-popup mag-popup_anim_vertical`

    if (media < MOBILE_WIDTH) {
      this.classList += ` ${this.modifier}_media`
    }

    this.initPopup()
  }

  _popupBeforeOpen = target => {
    this.options.beforeShow({
      this: this,
      target,
      render: this.render,
    })
  }

  _popupAfterClose() {
    this.nodes = {}
    this.slidesTotal = 0
    this.slidesCurrent = this.options.slideTo
    this._sliderDestroy()
    this.options.afterClose()
  }

  _appendPagination() {
    const { nodes, options, templates } = this

    if (options.createSlider && options.pagination) {
      nodes.imageBox.insertAdjacentHTML('beforeend', templates.paginationBox)
    }
  }

  _appendNavigation() {
    const { nodes, options, templates } = this

    if (options.createSlider && options.navigation) {
      nodes.imageBox.insertAdjacentHTML('beforeend', templates.navigationBox)
    }
  }

  _sliderInit() {
    const { options } = this
    const initialSlide = this.slidesCurrent
    const sliderOptions = this._sliderOptions()
    const optionsPagination = options.pagination

    if (this.slidesTotal === 1) {
      sliderOptions.simulateTouch = false
    }

    if (optionsPagination && this.slidesTotal > 1) {
      sliderOptions.pagination = this._getPagination()
    }

    this.Slider = new Swiper(`#${options.id}__image-container`, sliderOptions)

    if (initialSlide > 0) {
      this.Slider.slideTo(initialSlide, 0)
    }
  }

  _getPagination() {
    const { options, modifier } = this
    const optionsPagination = options.pagination

    const paginationDefault = {
      el: `.${modifier}__pagination`,
    }

    const paginationFraction = {
      type: 'fraction',
      renderFraction: (current, total) => {
        const template = `<span class="${current}"></span> из <span class="${total}"></span>`

        return template
      },
    }

    const paginationDynamic = {
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: this.slidesTotal < 3 ? 1 : 3,
    }

    if (optionsPagination === 'fraction') {
      return { ...paginationDefault, ...paginationFraction }
    }

    if (optionsPagination === 'dynamic') {
      return { ...paginationDefault, ...paginationDynamic }
    }
  }

  _sliderOptions() {
    const { modifier } = this

    const optionsDefault = {
      containerModifierClass: `${modifier}-`,
      wrapperClass: `${modifier}__image-track`,
      slideClass: `${modifier}__slide`,
      slideActiveClass: `${modifier}__slide_active`,
      slidePrevClass: `${modifier}__slide-prev`,
      slideNextClass: `${modifier}__slide-next`,
      speed: 400,
      roundLengths: true,
      spaceBetween: 5,
      navigation: {
        prevEl: `.${modifier}__navigation-prev`,
        nextEl: `.${modifier}__navigation-next`,
        disabledClass: `${modifier}__navigation-button_hidden`,
      },
      on: {
        slideChange: () => {
          this._slideChange()
        },
      },
    }

    return { ...optionsDefault, ...this.sliderOptions }
  }

  _sliderDestroy() {
    if (this.Slider) {
      this.Slider.destroy(true)
    }
  }

  _slideChange() {
    this.slidesCurrent = this.Slider.activeIndex
    this.render()
    this.options.afterSlideChange({
      slider: this.Slider,
      slidesCurrent: this.slidesCurrent,
    })
  }
}
